if (!customElements.get('momo-collection-categories')) {
  customElements.define('momo-collection-categories', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const { signal } = this.events;
      const dropdown = this.querySelector('details');
      const sortSelect = this.querySelector('select[name="sort_by"]');
      // An old bookmark may still request a sort option removed from this page.
      if (sortSelect && !Array.from(sortSelect.options).some((option) => option.value === this.dataset.sort)) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.replace(url.href);
        return;
      }
      sortSelect?.addEventListener('change', (event) => {
        // Keep the current tag path (and preview parameters), but reset pagination.
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        url.hash = 'CollectionProducts';
        window.location.assign(url.href);
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && dropdown?.open) {
          dropdown.open = false;
          dropdown.querySelector('summary').focus();
        }
      }, { signal });
      document.addEventListener('click', (event) => {
        if (dropdown?.open && !dropdown.contains(event.target)) dropdown.open = false;
      }, { signal });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
